var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":_vm.currentSpace.agenda_content,"width":"200%","height":"2800px","frameborder":"0","marginheight":"0","marginwidth":"0","allow":"autoplay; fullscreen; camera *;   microphone *"}},[_vm._v("Loading…")])}
var staticRenderFns = []

export { render, staticRenderFns }